export default "__VITE_ASSET__BhfOSDN___"